import { defa } from 'defa-object';

/**
 * defa.views.UnitTestView
 * A view for a single unit test block.
 * @version 1.2.0
 */
import View from 'scripts/poppet/view';
import template from 'templates/unitTestView.jst.html'

const selectors = {
	container : '[data-container=unit-test-definitions]',
	buttonTest: '[data-loader=test]',
};

const rootUrl = defa.vars.baseURI;



const UnitTestView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	template : template,
	className: 'hidden',
	
	ui: {
		container: selectors.container,
	},
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	/**
	 * Triggers before the view is attached.
	 * @void
	 */
	onRender: function () {
		
		let html5 = '';
		
		if ( this.model.get( 'message' ) ) {
			html5 += this.printMessage( this.model.get( 'message' ) );
		}
		
		if ( this.model.get( 'tests' ).length > 0 ) {
			html5 += this.printTests( this.model.get( 'tests' ) );
		}
		
		this.$el.find( selectors.container ).append( html5 );
		
	},
	
	/**
	 * Triggers when the view is shown.
	 * @void
	 */
	onAttach: function () {
		//var buttonUrl
		let self  = this,
			tests = _.filter( self.model.get( 'tests' ), function ( test ) {
				return test.hasOwnProperty( 'buttonUrl' );
			} );
		// if a filtered test array has any item with a button.
		if ( tests.length >= 1 ) {
			
			// for each test find the correctly now rendered button, and attach the correct json to it.
			_.each( tests, function ( test ) {
				let $btn = self.$el.find( '[data-url="' + test.buttonUrl + '"]' );
				$btn.data( 'data', test.buttonData );
			} );
			
			// activate the clicker for all the buttons
			this.$el.find( '[data-loader=test]' ).on( 'click', function ( event ) {
				
				let $target = $( event.target ).closest( '[data-loader=test]' ),
					$ttext  = $target.find( '.loader-text' ),
					$parent = $target.parents( 'dd' ),
					$text   = $parent.find( '[data-text=target]' );
				
				$target.addClass( 'loading' );
				
				let data = JSON.stringify( $target.data( 'data' ) );
				$.ajax( {
					 url        : rootUrl + $target.attr( 'data-url' ),
					 method     : 'PUT',
					 contentType: 'application/json',
					 data       : data,
				 } )
				 .done( function ( response ) {
					
					 // check if we need to create JSON out of the response first.
					
					 $parent
						 .removeClass()
						 .addClass( response.status );
					
					 $text
						 .text( response.result );
					
					 $target
						 .removeClass( 'loading' )
						 .attr( 'data-url', response.buttonUrl )
						 .data( 'data', response.buttonData );
					
					 $ttext
						 .text( response.buttonText );
				 } )
				 .fail( function ( /* response */ ) {
					 $target.removeClass( 'loading' );
				 } );
			} );
			
			
		}
		
		// !TODO: use the new expand block - 1.4.0
		$( document ).off( 'click', '.info-icon' ); // tiny-hack, remove old listener before adding the new one, this
													// get set too often, IE-issues/Sauron etc, fix later by using the
													// expand-spoiler classes instead.
		
		$( document ).on( 'click', '.info-icon', function ( event ) {
			$( event.target ).parents( 'dl' ).find( '.info' ).find( 'div' ).toggleClass( 'hidden' );
		} );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Print the message
	 * @param  {String} message  The message string when there are no tests.
	 * @return {String}          The html-formatted result of the message.
	 */
	printMessage: function ( message ) {
		return '<p>%s</p>'.replace( '%s', message );
	},
	
	/**
	 * Print the definition list
	 * @param  {Array}  tests  The test array.
	 * @return {String}        The html-formatted results of the tests.
	 */ // !TODO: Move more of this template into the view file
	printTests: function ( tests ) {
		
		let html5 = '';
		
		_.each( tests, function ( test ) {
			
			let buttonHtml = '';
			
			buttonHtml += '<button class="loader normal-width primary" data-loader="test" data-url="%s1">';
			buttonHtml += '<span class="loader-spinner">';
			buttonHtml += '<span class="bounce1"></span>';
			buttonHtml += '<span class="bounce2"></span>';
			buttonHtml += '<span class="bounce3"></span>';
			buttonHtml += '</span>';
			buttonHtml += '<span class="loader-text">';
			buttonHtml += '%s2';
			buttonHtml += '</span>';
			buttonHtml += '</button>';
			
			let button = ( test.buttonUrl )
						 ? buttonHtml
							 .replace( '%s1', test.buttonUrl )
							 .replace( '%s2', test.buttonText )
						 : '';
			
			
			html5 += '<dt class="align-left">%s</dt>'
				.replace( '%s', test.test );
			
			html5 += '<dd class="%s1"><span class="push-right" data-text="target">%s2</span> %s3</dd>'
				.replace( '%s1', test.status )
				.replace( '%s2', test.result )
				.replace( '%s3', button );
		} );
		
		// append info if available:
		if ( this.model.get( 'info' ) ) {
			html5 += '<dt class="align-left"><button class="ir info-icon"><span class="screen-reader-only"></span></button></dt>';
			html5 += '<dd class="info"><div class="hidden">%s</div></dd>'
				.replace( '%s', this.model.get( 'info' ) );
		}
		
		return '<dl>%s</dl>'.replace( '%s', html5 );
	},
	
	
} );


export default UnitTestView;